/**
 * @constructor
 * @class Generic base class to represent an SVG object.
 */
let SVGMap = function(id, left, top, width, height) {

  var d=document,
      map=this,
      ns=this.ns="http://www.w3.org/2000/svg";

  this.svg= id ? d.getElementById(id) : d.createElement("SVG");

  this.size={ x:left, y:top, width:width, height:height }

  this.values={};
  this.labels=[];
  this.tooltip={ enabled:true }

  var sa=this.svg.setAttribute;
  sa.call(this.svg,"version", "1.2");
  sa.call(this.svg,"baseProfile", "tiny");

  sa.call(this.svg,"viewBox", ""+left+" "+top+" "+width+" "+height);

  var content=this.content=d.createElementNS(ns, "g");
  content.setAttribute("id", "content");

  // css box-shadow not available for SVG elements:
  /*
  <defs>
    <filter id="f1" x="0" y="0" width="200%" height="200%">
      <feOffset result="offOut" in="SourceAlpha" dx="20" dy="20" />
      <feGaussianBlur result="blurOut" in="offOut" stdDeviation="10" />
      <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
    </filter>
  </defs>
  */

  this.svg.onmousemove=function(e) {
    if (!map.tooltip.enabled) return;

    var items=this.ownerDocument.elementFromPoint(e.clientX, e.clientY),
        id=items.getAttribute("id"),
        s=map.labels[id], v=map.values[id];

    if (s === undefined) {
      if (map.onhoverout)
        map.onhoverout(id);
    }
    else
    {
      if (v !== undefined) s+="<br/>"+v;

      Tee.DOMTip.show(s);

      if (map.onhover)
          map.onhover(id);
    }
  }

  this.svg.onmouseup=function(e) {
   var items=this.ownerDocument.elementFromPoint(e.clientX, e.clientY),
       id=items.getAttribute("id");

   if (map.onclick && id && (id !== undefined) && (items!==this))
      map.onclick( id, items);
  }

  this.svg.onmouseout=function() {
    if (map.tooltip.enabled)
        Tee.DOMTip.hide();
  }

  var matrix=[1,0,0,1,0,0];

  function zoom(factor) {
    for (var t=0; t<matrix.length; t++)
         matrix[t] *= factor;

    var b=map.svg.viewBox.baseVal;

    matrix[4] += (1-factor)*b.width*0.5;
    matrix[5] += (1-factor)*b.height*0.5;

    content.setAttributeNS(null, "transform", "matrix("+ matrix.join(' ')+ ")");
  }

  function createButton(id, x, y) {

    var group=d.createElementNS(ns, "g");

    group.setAttribute("id",id);
    group.setAttribute("class", "button");
    group.setAttribute("cursor", "pointer");

    var r=d.createElementNS(ns, "rect");

    r.setAttribute("x", x + left);
    r.setAttribute("y", y + top);
    r.setAttribute("width", 150);
    r.setAttribute("height", 150);
    r.setAttribute("rx", 40);
    r.setAttribute("style", "fill:#CCAA22; stroke:black;");

    group.appendChild(r);
    map.svg.appendChild(group);

    return group;
  }

  this.createRect=function(x,y,width,height) {
    var r=d.createElementNS(ns, "rect");

    r.setAttribute("x", this.size.x + x);
    r.setAttribute("y", this.size.y + y);
    r.setAttribute("width", width);
    r.setAttribute("height", height);
    return r;
  }

  this.addZoomButtons=function() {
    var top=50,
        zoomin=createButton("zoomin", 25, top);

    zoomin.appendChild(this.createRect(45,top+55,110,40));
    zoomin.appendChild(this.createRect(80,top+20,40,110));
    zoomin.onclick=function() { zoom(1.1); }

    top+=240;
    var zoomout=createButton("zoomout", 25, 250);
    zoomout.appendChild(this.createRect(45,top+20,110,40));
    zoomout.onclick=function() { zoom(0.9); }
  }

  // Change all polygon colors according to a "colors" palette and each
  // polygon value.
  // Returns a legend (an array of: { min,max,color } )

  this.applyPalette=function(colors) {

    this.palette=colors;

    var b=this.content.childNodes, l=b.length, i,
        v=this.values,
        min=Infinity,
        max=-min,
        hasValue,
        //lV=v.length,
        o, v2, v3, range=0,
        result=[];

    if (colors) {
      for(o in v) {
        v2=v[o];
        if (v2<min) min=v2; else
        if (v2>max) max=v2;
      }

      range=(max-min)/colors.length;

      for(i=0; i<colors.length; i++)
        result.push({ min: min+i*range, max: min+(i+1)*range, color: colors[i]});
    }

    // Traverse all polygons

    if (colors && (range>0))

      while(i=b[--l]) {
        hasValue=v[i.id];

        if (hasValue) {
          v3=((hasValue-min)/range) | 0;
          if (v3==colors.length) v3--;

          i.style.fill=colors[v3];
        }
        else
          i.style.fill="";
      }
    else
      while(i=b[--l])
        i.style.fill="";

    result.map=this;
    return result;
  }

  this.find=function(id) {
    return this.svg.ownerDocument.getElementById(id);
  }
}

export { SVGMap }

